// @ts-nocheck
import moment from 'moment'
import { all, call, getContext, put, takeLatest } from 'redux-saga/effects'
import { IReservation } from '../../models'
import { urls } from '../../routing'
import {
  FeedbackService,
  LiteralsService,
  ReservationService,
  UserService
} from '../../services'
import {
  deleteReservationSuccessfulAction,
  setErrorCancelReservationModalAction,
  fetchMorePastReservationsSuccessfulAction,
  fetchMoreReservationsSuccessfulAction,
  fetchPastReservationsSuccessfulAction,
  fetchRefundedReservationsSuccessfulAction,
  fetchReservationDetailsSuccessfulAction,
  fetchReservationsSuccessfulAction,
  setIsDeletingReservationAction,
  setIsFetchingMorePastReservationsAction,
  setIsFetchingPastReservationsAction,
  setIsFetchingRefundedReservationsAction,
  setIsFetchingReservationDetailsAction,
  setIsFetchingReservationsAction,
  setIsMoreFetchingReservationsAction,
  setNotificationAction,
  setStripeAccountId
} from '../actions'
import { ReservationsTypeKeys } from '../types'
import { Application } from '../../config'
import { HttpStatusCode } from 'axios'

const { isIframe } = Application

// Worker Saga
function* fetchReservationsAsync() : any {
  let orderedReservations = []
  let reservations = []
  let cancelledReservations = []

  yield put(setIsFetchingReservationsAction())
  try {
    reservations = yield call(ReservationService.getReservations)
  } catch (error) {
    yield put(
      setNotificationAction({
        isError: true,
        label: LiteralsService.get('serverError', true)
      })
    )
  }

  try {
    // Get cancelled and add flag to show flag
    cancelledReservations = yield call(
      ReservationService.getCancelledReservations
    )
  } catch (error) {
    yield put(
      setNotificationAction({
        isError: true,
        label: LiteralsService.get('serverError', true)
      })
    )
  }

  const cancelledReservationsWithFlag = cancelledReservations.map(
    (r: IReservation) => ({
      ...r,
      cancelled: true
    })
  )

  // Order reservations by date after concat both
  const bothReservationsArray = reservations.concat(
    cancelledReservationsWithFlag
  )

  orderedReservations = bothReservationsArray.sort(
    (a: IReservation, b: IReservation) =>
      moment(a.beginningStop.dateTime).diff(moment(b.beginningStop.dateTime))
  )

  yield put(fetchReservationsSuccessfulAction(orderedReservations))
}

function* fetchMoreReservationsAsync(action: any) : any {
  let reservations = []
  yield put(setIsMoreFetchingReservationsAction())
  try {
    reservations = yield call(ReservationService.getMoreReservations, action.payload.size, action.payload.page)
  } catch (error) {
    yield put(
      setNotificationAction({
        isError: true,
        label: LiteralsService.get('serverError', true)
      })
    )
  }
  yield put(fetchMoreReservationsSuccessfulAction(reservations))
}

function* fetchPastReservationsAsync(action: any) : any {
  let pastReservations = []
  try {
    yield put(setIsFetchingPastReservationsAction())
    pastReservations = yield call(ReservationService.getPastReservations, action.payload.size, action.payload.page)
  } catch (error) {
    yield put(
      setNotificationAction({
        isError: true,
        label: LiteralsService.get('serverError', true)
      })
    )
  }
  yield put(fetchPastReservationsSuccessfulAction(pastReservations))
}

function* fetchMorePastReservationsAsync(action: any) : any {
  let pastReservations = []
  try {
    yield put(setIsFetchingMorePastReservationsAction())
    pastReservations = yield call(ReservationService.getPastReservations, action.payload.size, action.payload.page)
  } catch (error) {
    yield put(
      setNotificationAction({
        isError: true,
        label: LiteralsService.get('serverError', true)
      })
    )
  }
  yield put(fetchMorePastReservationsSuccessfulAction(pastReservations))
}

function* fetchRefundedReservationsAsync() : any {
  let refundedReservations = []
  try {
    yield put(setIsFetchingRefundedReservationsAction())
    refundedReservations = yield call(ReservationService.getRefundedReservations)
  } catch (error) {
    yield put(
      setNotificationAction({
        isError: true,
        label: LiteralsService.get('serverError', true)
      })
    )
  }
  yield put(fetchRefundedReservationsSuccessfulAction(refundedReservations))
}

function* fetchReservationDetailsAsync(action: any) : any {
  let reservation
  let feedback
  let relatedReservation
  try {
    yield put(setIsFetchingReservationDetailsAction())
    reservation = yield call(
      !action.payload.cancelled
        ? ReservationService.getReservation
        : ReservationService.getCancelledReservation,
      action.payload.id
    )

    if (action.payload.relatedId) {
      relatedReservation = yield call(
        !action.payload.cancelled
          ? ReservationService.getReservation
          : ReservationService.getCancelledReservation,
        action.payload.relatedId
      )
    }
    if (relatedReservation) reservation = {
      ...reservation,
      returnDate: relatedReservation.dateTime,
      returnAvailabilityId: relatedReservation.availabilityId,
      relatedReservationId: action.payload.relatedId
    }

    try {
      feedback = yield call(FeedbackService.getReservationFeedback, action.payload.id)
    } catch (error: any) {
      if (!(error.status === HttpStatusCode.NotFound)) {
        yield put(
          setNotificationAction({
            isError: true,
            label: LiteralsService.get('serverError', true)
          })
        )
      }
    }
    if (action.payload.cancelled) reservation = { ...reservation, cancelled: true }
  } catch (error) {
    yield put(
      setNotificationAction({
        isError: true,
        label: LiteralsService.get('serverError', true)
      })
    )
  }

  if (!isIframe) {
    try {
      const userInfo = yield call(UserService.getInfo)
      if (!userInfo.accountId) {
        const { accountId } = yield call(UserService.getPaymentConfig, reservation.service.id)
        yield put(setStripeAccountId(accountId))
      }
    } catch (error: any) {
      if (!(error.status === HttpStatusCode.NotFound)) {
        yield put(
          setNotificationAction({
            isError: true,
            label: LiteralsService.get('serverError', true)
          })
        )
      }
    }
  }
  
  yield put(fetchReservationDetailsSuccessfulAction({...reservation, feedback }))
}

function* deleteReservationAsync(action: any) : any {
  const routerHistory = yield getContext('routerHistory')

  try {
    yield put(setIsDeletingReservationAction())
    yield call(ReservationService.deleteReservation, action.payload.id, action.payload.comment)
    yield call(routerHistory.push, urls.reservations)
    yield put(
      setNotificationAction({
        isError: false,
        label: LiteralsService.get('reservationDeleted', true)
      })
    )
  } catch (error: any) {
    if (error.status === HttpStatusCode.PreconditionFailed) {
      yield put(setErrorCancelReservationModalAction(true))
    } else {
      yield put(
        setNotificationAction({
          isError: true,
          label: LiteralsService.get('reservationNotDeleted', true)
        })
      )
    }
  }
  yield put(deleteReservationSuccessfulAction())
}

// Watcher Saga:
function* watchFetchReservationsAsync() {
  yield takeLatest(ReservationsTypeKeys.FETCH_RESERVATIONS, fetchReservationsAsync)
}

function* watchFetchMoreReservationsAsync() {
  yield takeLatest(ReservationsTypeKeys.FETCH_MORE_RESERVATIONS, fetchMoreReservationsAsync)
}

function* watchFetchPastReservationsAsync() {
  yield takeLatest(ReservationsTypeKeys.FETCH_PAST_RESERVATIONS, fetchPastReservationsAsync)
}

function* watchFetchMorePastReservationsAsync() {
  yield takeLatest(ReservationsTypeKeys.FETCH_MORE_PAST_RESERVATIONS, fetchMorePastReservationsAsync)
}

function* watchFetchRefundedReservationsAsync() {
  yield takeLatest(ReservationsTypeKeys.FETCH_REFUNDED_RESERVATIONS, fetchRefundedReservationsAsync)
}

function* watchFetchReservationDetailsAsync() {
  yield takeLatest(ReservationsTypeKeys.FETCH_RESERVATION_DETAILS, fetchReservationDetailsAsync)
}

function* watchDeleteReservationAsync() {
  yield takeLatest(ReservationsTypeKeys.DELETE_RESERVATION, deleteReservationAsync)
}

// single entry point to start all Sagas at once
export default function* rootSaga() {
  yield all([
    watchFetchReservationsAsync(),
    watchFetchMoreReservationsAsync(),
    watchFetchPastReservationsAsync(),
    watchFetchMorePastReservationsAsync(),
    watchFetchRefundedReservationsAsync(),
    watchFetchReservationDetailsAsync(),
    watchDeleteReservationAsync(),
  ])
}
